"use client";

import React from "react";

export default function TeacherSkeleton() {
  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% { background-position: -1000px 0; }
          100% { background-position: 1000px 0; }
        }

        .shimmer {
          background: linear-gradient(
            90deg,
            #e8e8e8 0%,
            #f3f3f3 25%,
            #e8e8e8 50%,
            #f3f3f3 75%,
            #e8e8e8 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite linear;
        }
      `}</style>

      {/* Notice: No background image, no negative margins, and no "MEET OUR TEACHERS" heading here.
        This skeleton ONLY represents the slider itself, since the parent handles the background.
      */}
      <div className="relative flex flex-row gap-3 lg:gap-10">
        
        {/* LEFT Arrow Placeholder (Desktop only) */}
        <div className="hidden xl:flex items-center mb-4">
          <div className="w-10 h-10 lg:w-20 lg:h-20 rounded-full shimmer bg-gray-200 pl-0" />
        </div>

        {/* Cards Container */}
        <div className="flex-1 overflow-hidden -mr-5 md:-mr-8 lg:-mx-16 xl:-mr-32 2xl:-mr-1 max-[1200px]:!ml-[10px]">
          <div className="flex gap-3 pb-10 overflow-hidden">
            {[1, 2, 3, 4, 5].map((index) => (
              <article
                key={index}
                className="flex-shrink-0 bg-white rounded-2xl pb-14 border border-gray-100 shadow-sm"
              >
                {/* Image Placeholder */}
                <div className="relative m-[4px] rounded-2xl overflow-hidden bg-slate-100">
                  <div className="relative aspect-[3/3] min-w-[300px] h-[255px] xl:w-[350px] xl:h-[300px] shimmer">
                    
                    {/* Experience Badge Placeholder */}
                    <div className="absolute bottom-8 left-0 w-[144px] h-[50px] md:w-[174px] md:h-[60px] bg-gray-300 opacity-60 rounded-r-md" />
                  
                  </div>
                </div>

                {/* Text Details Placeholder */}
                <div className="px-4 pb-4 pt-4">
                  {/* Name Skeleton */}
                  <div className="h-[24px] xl:h-[32px] w-[200px] bg-gray-200 rounded shimmer mb-3" />
                  
                  {/* Qualification Skeleton */}
                  <div className="h-[18px] xl:h-[22px] w-[260px] bg-gray-200 rounded shimmer" />
                </div>
              </article>
            ))}
          </div>

          {/* Pagination Dots Placeholder */}
          <div className="flex justify-center items-center gap-4 mt-2">
            <div className="w-4 h-4 rounded-full bg-gray-200 shimmer" />
            <div className="w-4 h-4 rounded-full bg-[#0097DC] opacity-30" />
            <div className="w-4 h-4 rounded-full bg-gray-200 shimmer" />
          </div>
        </div>
      </div>
    </>
  );
}
